import * as React from "react";
import { cn } from "@ds/lib/utils";

/** InfoBanner — Capture Sheet field 12.22. Muted well, leading mark, bold title, one supporting line. */
function InfoBanner({
  className,
  leading,
  title,
  description,
  action,
}: {
  className?: string;
  leading?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
}) {
  return (
    <div
      data-slot="info-banner"
      className={cn("flex items-start gap-3 rounded-card bg-muted px-4 py-3.5", className)}
    >
      {leading ? (
        <span className="text-foreground shrink-0 [&_svg]:size-5" aria-hidden>
          {leading}
        </span>
      ) : null}
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="text-row text-foreground">{title}</span>
        {description ? (
          <span className="text-support text-muted-foreground">{description}</span>
        ) : null}
        {action ? <span className="mt-2">{action}</span> : null}
      </div>
    </div>
  );
}

export { InfoBanner };
